module.exports = __webpack_public_path__ + "static/media/expand-chevron.fd7409a7.svg";